import { BrowserModule } from "@angular/platform-browser";
import { LOCALE_ID, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { HttpModule } from "@angular/http";

import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { AngularEchartsModule } from "ngx-echarts";
import { Angular2FontawesomeModule } from "angular2-fontawesome/angular2-fontawesome";

import { AppComponent } from "./app.component";
import { AccountListComponent } from "./account-list/account-list.component";
import { AccountInfomationComponent } from "./account-infomation/account-infomation.component";
import { LoginComponent } from "./login/login.component";

import { RouteRoutingModule } from "./route/route-routing.module";

import { HttpService } from "./http.service";
import { AccountService } from "./account.service";
import { ProductService } from "./product.service";
import { EnergystorageService } from "./energystorage.service";
import { SmartPanelService } from "./smart-panel.service";
import { AdrSystemService } from "./adr-system.service";

import { ProductListComponent } from "./product-list/product-list.component";
import { ProductInfomationComponent } from "./product-infomation/product-infomation.component";
import { AccountTypePipe } from "./account-type.pipe";
import { AccountPermissionPipe } from "./account-permission.pipe";
import { ProductTypePipe } from "./product-type.pipe";
import { AccountEditComponent } from "./account-edit/account-edit.component";
import { ProductEditComponent } from "./product-edit/product-edit.component";

import { EnergyStorageComponent } from "./Page/energy-storage/energy-storage.component";

import { EnergyStorageDetailComponent } from "./component/energy-storage-detail/energy-storage-detail.component";
import { SmartPanelComponent } from "./Page/smart-panel/smart-panel.component";
import { SmartPanelDetailComponent } from "./component/smart-panel-detail/smart-panel-detail.component";
import { SmartCbdetailComponent } from "./component/smart-cbdetail/smart-cbdetail.component";
import { Opti2k5kDetailComponent } from "./Component/ESS-BA20GA30IGW/opti2k5k-detail/opti2k5k-detail.component";
import { Fspbs4866DetailComponent } from "./Component/ESS-BA20GA30IGW/fspbs4866-detail/fspbs4866-detail.component";
import { ChipseeA9SysteminfoComponent } from "./Component/chipsee-a9-systeminfo/chipsee-a9-systeminfo.component";
import { Dse7200Component } from "./Component/ESS-BA20GA30IGW/dse7200/dse7200.component";
import { PhasorChartComponent } from "./Component/phasor-chart/phasor-chart.component";
import { LwfSeriesComponent } from "./Component/lwf-series/lwf-series.component";
import { AdrSystemComponent } from "./Page/adr-system/adr-system.component";

@NgModule({
  declarations: [
    AppComponent,
    AccountListComponent,
    AccountInfomationComponent,
    LoginComponent,
    ProductListComponent,
    ProductInfomationComponent,
    AccountTypePipe,
    AccountPermissionPipe,
    ProductTypePipe,
    AccountEditComponent,
    ProductEditComponent,
    EnergyStorageComponent,
    EnergyStorageDetailComponent,
    SmartPanelComponent,
    SmartPanelDetailComponent,
    SmartCbdetailComponent,
    Opti2k5kDetailComponent,
    Fspbs4866DetailComponent,
    ChipseeA9SysteminfoComponent,
    Dse7200Component,
    PhasorChartComponent,
    LwfSeriesComponent,
    AdrSystemComponent
  ],
  imports: [
    NgbModule.forRoot(),
    BrowserModule,
    RouteRoutingModule,
    FormsModule,
    AngularEchartsModule,
    CommonModule,
    Angular2FontawesomeModule,
    HttpModule
  ],
  providers: [
    HttpService,
    AccountService,
    ProductService,
    EnergystorageService,
    SmartPanelService,
    AdrSystemService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}



// WEBPACK FOOTER //
// D:/Git/MSPC_CP/02_CloudServer/10_GIGAENERGY_Server/web/src/app/app.module.ts